module.exports = __webpack_public_path__ + "assets/img/images-columns-2.334ed9c1.jpg";